module.exports = __webpack_public_path__ + "static/media/b1.321b387.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhangxinyuan/b1.mp3
// module id = VcyI
// module chunks = 0